/**
 * Interface for the 'Teams' data
 */
export interface TeamsEntity {
  auction: string
  created: string
  order: number
  profiles_count: number
  name: string
  updated: string
  uuid: string
}

export enum TeamModeEnum {
  Add = 'add',
  View = 'view',
}
